import React from 'react';
import { Button } from './primitives';
import { FOUNDER_FORM_HREF, MENTOR_FORM_HREF } from '../content';
import { SCENE_IMG, PORTRAIT } from '../media';
export function TwoDoors() {
  return <section id="join" className="theme-dark relative overflow-hidden bg-background text-foreground" aria-label="Join basecamp" data-id="element-109" data-mp="bvvkg9vgiqnh">
      <img src={SCENE_IMG.sunsetRidge} alt="" className="absolute inset-0 h-full w-full object-cover object-[50%_45%]" data-id="element-110" data-mp="gsluogkkys0z" />
      <div className="absolute inset-0 bg-[rgba(0,31,15,0.4)]" data-id="element-111" data-mp="6wix7o0obhkd" />

      <div className="section-shell relative grid gap-5 py-16 md:grid-cols-2 lg:py-20" data-id="element-112" data-mp="6twgoyvt1rq0">
        <article id="founders-door" className="flex scroll-mt-32 flex-col rounded-lg border border-[rgba(252,250,244,0.14)] bg-[rgba(0,31,15,0.62)] p-8 lg:p-10" aria-labelledby="founders-door-heading" data-id="element-113" data-mp="3p3yhxf8xdruo">
          <p className="overline" data-id="element-114" data-mp="1s9vg38n9ru4x">Founders</p>
          <h2 id="founders-door-heading" className="mt-5 font-serif text-h3" data-id="element-115" data-mp="1s8u0qrz80lhe">
            Building something inspired by nature?
          </h2>
          <p className="mt-4 max-w-md text-body leading-body text-muted-foreground" data-id="element-116" data-mp="2e1e65qen8223">
            Tell us about it and where you&rsquo;re headed next. We read every one.
          </p>

          {/* Who actually reads them. */}
          <figure className="m-0 mt-6 flex items-center gap-4" data-id="element-117" data-mp="2muhfpnm63urg">
            <img src={PORTRAIT.natalya} alt="Natalya Wallin" loading="lazy" className="h-14 w-14 shrink-0 rounded-full object-cover object-top" data-id="element-118" data-mp="1z3bz368ekyg3" />
            <figcaption data-id="element-119" data-mp="2921k37vliz0k">
              <p className="text-body-sm font-semibold" data-id="element-120" data-mp="292kv04mtwn53">Natalya Wallin</p>
              <p className="text-caption text-muted-foreground" data-id="element-121" data-mp="242f62w7y1eqp">Chief Executive Officer</p>
            </figcaption>
          </figure>

          <div className="mt-auto pt-8" data-id="element-122" data-mp="3kfdj95geutge">
            <Button href={FOUNDER_FORM_HREF} data-id="element-123" data-mp="3fi3u7qwxojt3">Tell us about you</Button>
          </div>
        </article>

        <article id="mentors-door" className="flex scroll-mt-32 flex-col rounded-lg border border-[rgba(252,250,244,0.14)] bg-[rgba(0,31,15,0.62)] p-8 lg:p-10" aria-labelledby="mentors-door-heading" data-id="element-124" data-mp="3nitavqi1mtk8">
          <p className="overline" data-id="element-125" data-mp="f503qu235nz">Mentors</p>
          <h2 id="mentors-door-heading" className="mt-5 font-serif text-h3" data-id="element-126" data-mp="5cwselym4tsp">
            Been up this mountain before?
          </h2>
          <p className="mt-4 max-w-md text-body leading-body text-muted-foreground" data-id="element-127" data-mp="33vbx5ehyu4ns">
            Help someone else climb it faster.
          </p>
          <div className="mt-auto pt-8" data-id="element-128" data-mp="38rkixaqo4w3x">
            <Button href={MENTOR_FORM_HREF} data-id="element-129" data-mp="3ds895u72p8x3">Become a mentor</Button>
          </div>
        </article>
      </div>
    </section>;
}